import React, {Component, Fragment} from 'react'
import {message, Upload, Icon,} from 'antd';
import {baseUrl, hscreenBaseUrl, fileThumb} from '../../api'
import ajax from "../../api/ajax";
import CryptoJS from '../../utills/crypto'
import {download} from '../../utills/picture-download'
export default class FileUpload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            readOnly: true,
            fileList: [],//境内传文件列表，境外需要调用接口
        };
        this.realBaseUrl = props.exterior ? hscreenBaseUrl : baseUrl;
    }

    componentDidMount() {
        const {readOnly, fileList} = this.props;
        this.setState({readOnly, fileList,});
    }

    componentDidUpdate(preProps, preState, snapShot) {
        const {readOnly, objectType, fileList,} = this.props;
        //readOnly动态改变时
        if (readOnly !== preProps.readOnly) {
            this.setState({readOnly})
        }
        if (objectType && Array.isArray(fileList) && (!Array.isArray(preProps.fileList) || preProps.fileList.length !== fileList.length)) {
            this.setState({fileList})
        }
    }

    getThumbUrl = (fileName) => {
        let thumbUrl = "";
        if (fileName.toLowerCase().endsWith(".docx") || fileName.toLowerCase().endsWith(".doc")) {
            thumbUrl = fileThumb.word
        } else if (fileName.toLowerCase().endsWith(".xlsx") || fileName.toLowerCase().endsWith(".xls")) {
            thumbUrl = fileThumb.excel
        } else if (fileName.toLowerCase().endsWith(".pdf")) {
            thumbUrl = fileThumb.pdf
        }
        return thumbUrl
    };

    handleBeforeUpload = (f, fList) => {
        return new Promise((resolve, reject) => {
            if (f.size > 10000000) {
                message.info("只能上传10M内文件");
                return reject(false);
            }
            return resolve(true);
        });
    };
    handleChange = info => {
        let fileList = [...info.fileList];
        fileList = fileList.map(file => {
            if (file.response) {
                if (file.response.code === 200) {
                    file.thumbUrl = this.getThumbUrl(file.response.data.fileName)
                    file.url = this.realBaseUrl + '/' + file.response.data.filePath;
                    file.id = file.response.data.id;
                } else {
                    file.status = 'error';
                    file.response = file.response.message;
                }
            }
            return file;
        });
        this.props.setFileList(fileList);
        this.setState({fileList});
    };
    handleRemove = info => {
        const {exterior, orderId, orderNo, objectType, driverName} = this.props;
        let result;
        if (exterior) {
            result = ajax(hscreenBaseUrl + '/d/public/scan/wx/delete', {
                content: CryptoJS.encrypt(JSON.stringify({
                    orderNo, type: objectType, fileId: info.id, driver: driverName
                }))
            }, 'POST');
        } else {
            result = ajax(baseUrl + '/api/v1/p/file/fileDel', {fileId: info.id, orderId}, 'DELETE');
        }
        result.then(function (value) {
            if (value.code === 200) {
                return true;
            } else {
                message.error(value.message);
                return false;
            }
        }, function (error) {
            message.error(error);
            return false;
        });
    };

    render() {
        const {readOnly, fileList,} = this.state;
        const {exterior, orderNo, objectId, objectType, driverName} = this.props;
        const realUploadUrl = exterior ?
            hscreenBaseUrl + '/d/public/scan/wx/upLoad' :
            baseUrl + '/api/v1/p/file/upLoad?orderId=' + (objectId != null ? objectId : '') + '&objectType=' + objectType;
        let props = {
            name: 'file',
            action: realUploadUrl,
            data: {content: CryptoJS.encrypt(JSON.stringify({orderNo, type: objectType, driver: driverName}))},
            multiple: true,
            listType: 'picture-card',
            withCredentials: true,
            showUploadList: {showDownloadIcon: false},
            beforeUpload: this.handleBeforeUpload,
            onChange: this.handleChange,
            onRemove: this.handleRemove,
        };
        if (readOnly || (exterior && objectId == null)) {
            props = {
                name: 'file',
                listType: 'picture-card',
                disabled: true,
                onDownload: (file) => download(file, exterior),
            };
        }
        return (
            <Fragment>
                {!readOnly && props.disabled ? <span style={{color: '#faad14'}}>先点击保存,才能上传附件</span> : null}
                <Upload {...props} fileList={fileList}>
                    {readOnly ? null : <Fragment><Icon type="upload"/>上传</Fragment>}
                </Upload>
            </Fragment>
        )
    }
}